import type { Product } from '../features/catalog/api'

/**
 * Оформление карточки товара.
 *
 * Плитка красится по категории: цвет обложки API не отдаёт, а однотонная
 * серая сетка витрины читается хуже. Это решение оформления, а не подмена
 * данных — как только у категории появится картинка, плитка уступит ей место.
 */
const TINTS = [
  'var(--tint-sand)',
  'var(--tint-sky)',
  'var(--tint-mint)',
  'var(--tint-lav)',
  'var(--tint-rose)',
]

export function categoryTint(categoryId: number): string {
  return TINTS[categoryId % TINTS.length] ?? 'var(--surface2)'
}

/** Производитель — вторая строка карточки; его может и не быть. */
export function productSubtitle(product: Product): string {
  return product.maker || product.categoryName
}

/** «38 000 сум»; цены нет — так и пишем (`unknown`), а не рисуем ноль. */
export function priceLabel(
  product: Pick<Product, 'price'>,
  money: (v: number) => string,
  unknown: string,
): string {
  return product.price ? money(product.price) : unknown
}
